import { render, staticRenderFns } from "./AttendanceAttend.vue?vue&type=template&id=16b4b38d&scoped=true&"
import script from "./AttendanceAttend.vue?vue&type=script&lang=js&"
export * from "./AttendanceAttend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b4b38d",
  null
  
)

export default component.exports